<script setup lang="ts">
</script>

<template>
  <div class="toc-design-content container-fluid">
    <slot></slot>
  </div>
</template>